import { render } from "./ViewNotifications.vue?vue&type=template&id=1f6653ee&scoped=true"
import script from "./ViewNotifications.vue?vue&type=script&lang=js"
export * from "./ViewNotifications.vue?vue&type=script&lang=js"

import "./ViewNotifications.vue?vue&type=style&index=0&id=1f6653ee&scoped=true&lang=css"

import exportComponent from "/home/saes/central_authentication/central_authentication_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f6653ee"]])

export default __exports__